module.exports = "/assets/sales-manago-logo.png?bLJNIMa";